import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import { useState } from "react";
import "@/App.css";

import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Loans from "@/pages/Loans";
import Insurance from "@/pages/Insurance";
import Property from "@/pages/Property";
import Contact from "@/pages/Contact";
import Apply from "@/pages/Apply";
import EmiCalculator from "@/pages/EmiCalculator";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CustomerDashboard from "@/pages/CustomerDashboard";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminForgotPassword from "@/pages/admin/AdminForgotPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminSettings from "@/pages/admin/AdminSettings";

function PublicShell() {
  const [settings, setSettings] = useState({});
  useEffect(() => { api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {}); }, []);
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen bg-[#0B0B0B]">
      <SiteHeader />
      <Outlet />
      <SiteFooter settings={settings} />
    </div>
  );
}

function CustomerRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-16 text-center text-white/60">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <Routes>
          {/* Admin standalone */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminOverview />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="customers" element={<AdminCustomers />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          {/* Public + customer */}
          <Route element={<PublicShell />}>
            <Route index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/loans" element={<Loans />} />
            <Route path="/loans/:slug" element={<Loans />} />
            <Route path="/insurance" element={<Insurance />} />
            <Route path="/property" element={<Property />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/emi-calculator" element={<EmiCalculator />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<CustomerRoute><CustomerDashboard /></CustomerRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
export default App;
